import { DataTableStateEvent, SortOrder } from "primereact/datatable";
import { useState } from "react";

interface SortState {
	sortField: string;
	sortOrder: number;
}

export function useTableState<TFilter extends { skip: number; take: number }>(initialFilter: TFilter) {
	const [sort, setSort] = useState<SortState>({ sortField: '', sortOrder: 0 });
	const [filter, setFilter] = useState<TFilter>(initialFilter);

	const onSort = (e: DataTableStateEvent) => setSort({
		sortField: e.sortField ?? '',
		sortOrder: e.sortOrder!,
	});

	const onPage = (e: DataTableStateEvent) => setFilter(prev => ({
		...prev,
		skip: e.first,
		take: e.rows,
	}) as TFilter);

	const updateFilter = (partial: Partial<TFilter>) => setFilter(prev => ({ ...prev, ...partial }));

	const tableProps = {
		first: filter.skip,
		rows: filter.take,
		onPage,
		onSort,
		sortField: sort.sortField,
		sortOrder: sort.sortOrder as SortOrder,
	};

	return { sort, filter, setSort, setFilter, onSort, onPage, updateFilter, tableProps };
}
